import { simpleUserVO } from "./../types/simpleTest";
import { MainApi } from "./MainApi";

export class SimpleTestApi {
  static baseUrl = `api/v1/dcas-simple/user`;

  static createSimpleUser = (simpleUserVO: simpleUserVO) => () => {
    return MainApi.api.post(`${SimpleTestApi.baseUrl}`, simpleUserVO);
  };
}
